'use client'

import React, { JSX } from 'react'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import TestimonialSectionSchema, {
  TestimonialSectionProps,
  TestimonialSectionDefaultValues,
  Testimonial,
} from './schema'
import TestimonialSection from '@/components/RevampedLanding/TestimonialSection'

export function TestimonialSectionWidget(props: Testimonial) {
  const { testimonialSection } = props
  // Replace with actual TestimonialSection component import and usage
  return <TestimonialSection testimonialData={testimonialSection} />
}

export default createWidget<Testimonial>({
  formType: TestimonialSectionSchema,
  render(props): JSX.Element {
    return <TestimonialSectionWidget {...props} />
  },
  id: 'Landing.Page.TestimonialSection',
  name: 'Landing Testimonial Section',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: TestimonialSectionDefaultValues,
})
